import { Close, Edit } from '@material-ui/icons';
import { CourseGroupModel } from 'apiServices/controllers/courseGroup';
import React from 'react';
import classes from '../course-groups-overview.module.scss';

interface CourseGroupsOverviewActionsProps {
  item: CourseGroupModel;
  key: number;
  onEdit: (item: CourseGroupModel, key: number) => void;
  onDelete: (item: CourseGroupModel, key: number) => void;
}

export const CourseGroupsOverviewActions = ({
  onEdit, onDelete, item, key,
}: CourseGroupsOverviewActionsProps) => (
  <div style={{ display: 'flex', marginLeft: '1em' }} className="actions-right">
    <button
      className={classes.button}
      type='button'
      onClick={(e) => {
        onEdit(item, key);
        e.preventDefault();
      }}>
      <Edit />
    </button>
    <button
      className={classes.button_left}
      type='button'
      onClick={(e) => {
        !item.courses?.length && onDelete(item, key);
        e.preventDefault();
      }}>
      <Close color={item.courses?.length ? 'disabled' : undefined} />
    </button>
  </div>
);
